import React from 'react';
const steps = [{
  num: '01',
  title: 'Onboard',
  desc: 'A quick kickoff to align on goals, audience, and what winning looks like.',
  when: '< 1 day'
}, {
  num: '02',
  title: 'Direction',
  desc: 'First concepts land while the brief is still fresh.',
  when: '4–5 days'
}, {
  num: '03',
  title: 'Design & build',
  desc: "Focused sprints with real feedback loops until it's genuinely right.",
  when: '2–4 weeks'
}, {
  num: '04',
  title: 'Launch',
  desc: 'We ship, hand over the files, and stick around for what comes after.',
  when: '+ support'
}];
export function Process() {
  return <section className="sec" data-id="element-171">
      <div className="sec__head" data-id="element-172">
        <div data-id="element-173">
          <div className="eyebrow mb-5" data-id="element-174">How it works</div>
          <h2 data-id="element-175">Days and weeks, not months.</h2>
        </div>
      </div>

      <div className="procwrap" data-id="element-176">
        <div className="proc" data-id="element-177">
          {steps.map(step => <div key={step.num} className="step" data-id="element-178">
              <div className="k" data-id="element-179">{step.num}</div>
              <h4 data-id="element-180">{step.title}</h4>
              <p data-id="element-181">{step.desc}</p>
              <div className="when" data-id="element-182">{step.when}</div>
            </div>)}
        </div>

        <p className="proc-note" data-id="element-183">
          First designs in four to five <span className="serif" data-id="element-184">days</span> —
          not four to five weeks.
        </p>
      </div>
    </section>;
}